const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "#F6F8FA",
    minHeight: "100vh",
  },
  appBar: {
    backgroundColor: theme.palette.darkGrey.main,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  formContainer: {
    paddingTop: "30px",
    paddingBottom: 100,
    width: "100%",
    backgroundColor: "#F6F8FA",
    minHeight: "calc(100vh - 64px)", // 64px est la hauteur de la AppBar
  },
  form: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  imageCard: {
    marginLeft: 10,
    maxWidth: 200,
    marginTop: 20,
  },
  imageCardMedia: {
    width: "100%",
    height: "100%",
    backgroundColor: "#E5E8EB",
  },
  uploadFile: {
    marginTop: 10,
    marginLeft: 10,
  },
  extendedIcon: {
    marginRight: theme.spacing(1),
  },
  enigmasButtons: {
    margin: theme.spacing(1),
  },
  link: {
    textDecoration: "none",
  },
  textFieldBig: {
    minWidth: 400,
  },
  listContainer: {
    display: "flex",
    justifyContent: "center",
  },
  list: {
    backgroundColor: theme.palette.lightGrey.main,
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
    borderRadius: 5,
    listStyle: "none",
    width: "60%",
  },
  buttonListPlus: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: 5,
    color: "white",
  },
  returnButtonLink: {
    textDecoration: "none",
  },
  whiteTextfield: {
    backgroundColor: "white",
  },
  saveButton: {
    backgroundColor: theme.palette.orange.main,
    color: theme.palette.darkGrey.main,
    fontSize: 15,
    fontWeight: 700,
    borderWidth: "0px",
    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  actionBar: {
    [theme.breakpoints.up("sm")]: {
      left: "280px !important",
    },
  },
  twoColsRow: {
    [theme.breakpoints.down("xs")]: {
      flexDirection: "column",
    },
  },
  coordsRow: {
    flexWrap: "wrap",
    "& > *": {
      flex: "1 1 140px",
    },
  },
  configContainer: {
    backgroundColor: "white",
    borderRadius: 12,
    padding: 24,
    boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
    height: "100%",
    overflow: "hidden",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: 16,
    },
  },
  emptyContainer: {
    backgroundColor: "white",
    borderRadius: 8,
    padding: 24,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
    height: "100%",
    minHeight: 400,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  containerWrapper: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  textFieldContainer: {
    backgroundColor: "#F8FAFC",
    borderRadius: 12,
    padding: 16,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: 12,
    transition: "background-color 0.2s ease",
  },
  textFieldContainerLight: {
    backgroundColor: "#F8FAFC",
    borderRadius: 12,
    padding: 16,
    width: "100%",
    marginBottom: 12,
    transition: "background-color 0.2s ease",
  },
  headerTextFieldDark: {
    color: "black",
    borderRadius: 5,
    fontWeight: 800,
  },
  switchFormControl: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    color: "#1E293B",
    borderRadius: 5,
    fontWeight: 600,
    fontSize: "1rem",
    marginBottom: 12,
  },
  headerTextField: {
    color: "black",
    borderRadius: 5,
    fontWeight: 700,
  },
  textField: {
    width: "100%",
    maxWidth: 400,
    backgroundColor: "white",
    borderRadius: 8,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: theme.palette.orange.main,
      },
    },
  },
  mapButton: {
    height: "auto",
    fontSize: 14,
    transition: "filter 0.2s ease",
    "&:hover": {
      filter: "brightness(0.97)",
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  select: {
    backgroundColor: "white",
    padding: 8,
    marginTop: 8,
    borderWidth: 1,
    borderRadius: 8,
    border: "1px solid #E2E8F0",
    width: "100%",
    maxWidth: 400,
    "&:hover": {
      borderColor: theme.palette.orange.main,
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: theme.palette.orange.main,
      },
    },
    "& .MuiInput-underline:before, & .MuiInput-underline:after": {
      display: "none",
    },
  },
  qrContainer: {
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("md")]: {
      marginLeft: 0,
    },
  },
  qrButton: {
    marginLeft: 0,
    color: theme.palette.darkGrey.main,
    width: "100%",
    maxWidth: 200,
    borderWidth: "0px",
    borderRadius: 8,
    fontWeight: 600,
    backgroundColor: theme.palette.orange.main,
    "&:hover": {
      backgroundColor: theme.palette.orange.dark,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
    height: 40,
    marginBottom: 16,
  },
  linkQrCodeButton: {
    textDecoration: "none",
    color: theme.palette.primary.main,
    backgroundColor: "#E3E8FA",
    fontWeight: 500,
    fontSize: 12,
    margin: theme.spacing(1),
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#C3CDEC",
      color: theme.palette.primary.main,
    },
    "&.Mui-focusVisible": {
      outline: `2px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  banner: {
    backgroundColor: "#B85A00",
    textAlign: "center",
    fontSize: 16,
    fontWeight: 900,
    padding: "15px",
    color: "white",
    borderRadius: "8px",
    margin: "16px",
    // marginBottom: "10px",
  },
  alignCenterSm: {
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      justifyContent: "start",
      alignItems: "start",
    },
  },
  buttonDisabled: {
    backgroundColor: "#CBD5E1",
    color: "#475569",
    cursor: "not-allowed",
    "&:hover": {
      backgroundColor: "#CBD5E1",
    },
  },
  textFieldCentereSm: {
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
    },
  },
  textFieldLgSm: {
    [theme.breakpoints.up("md")]: {
      textAlign: "left",
    },
  },
  mainContent: {
    marginLeft: 280,
    [theme.breakpoints.down("xs")]: {
      marginLeft: 0,
      marginTop: 0,
    },
  },
});

export default styles;
